export default __webpack_public_path__ + "static/media/menu.449d368e.png";